import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { LoadingService } from './loading.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { EntradaService } from '../entrada/entrada.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [CommonModule, MatProgressBarModule],
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.css'
})
export class LoadingComponent {
  public uploads: any[] = [];
  private loadingService = inject(LoadingService);
  private entradaService = inject(EntradaService);

  get isLoading() {
    return this.loadingService.isLoading;
  }
  
  get isLoadingFull() {
    return this.loadingService.isLoadingFull;
  }

  /*get _isLoadingTask() {
    if(this.loadingService.isLoading == false) {
      this.uploads = [];
      return false;
    }

    if(this.loadingService.isLoading == true && this.uploads.length == 0) {
      const taskAll = this.entradaService.getTaskUploadingEntrada();
      const listTask = taskAll.filter((item: any) => item._state == 'running');
      
      if(listTask.length == 0) 
        return false;

      for(let i = 0; i < listTask.length; i++) {
        const uploadTask = listTask[i];
        const uploadProgress$ = new Observable<string>(observer => {
          var unsubscribe = uploadTask.on('state_changed',
            (snapshot: any) => {
              const progress = ((snapshot.bytesTransferred / snapshot.totalBytes) * 100 ) +  '%';
              console.log('carga de arvhivo', snapshot.ref.name, progress);
              observer.next(progress);
            },
            (error: any) => {
              console.error(`Error al subir el archivo:`, error);
              unsubscribe();
              observer.error(error);
            },
            () => {
              console.log(i);
              unsubscribe();
              return observer.complete();
            }
          );
        });

        this.uploads.push({ name: 'Archivo ' + (i+1) , progress: uploadProgress$});
      }
    }

    return this.uploads.length > 0? true: false;
  }*/

  get isLoadingTask() {
    if(this.loadingService.isLoading == false) {
      this.uploads = [];
      return false;
    }

    if(this.loadingService.isLoading == true && this.uploads.length == 0) {
      const taskAll = this.entradaService.getTaskUploadingEntrada();
      const listTask = taskAll.filter((item: any) => item._state == 'running');
      
      if(listTask.length == 0) 
        return false;

      for(let i = 0; i < listTask.length; i++) {
        const uploadTask = listTask[i];
        
        uploadTask.on('state_changed',
          (snapshot: any) => {
            const progress = ((snapshot.bytesTransferred / snapshot.totalBytes) * 100 );
            console.log('carga de arvhivo', snapshot.ref.name, progress);
            this.uploads[i] = { 'name':  snapshot.ref.name, 'progress': progress + '%', progress_show: progress};
          },
          (error: any) => {
            console.error(`Error al subir el archivo:`, error);
          },
          () => {
            console.log('complete '+i);
          }
        );
      }
    }

    return this.uploads.length > 0? true: false;
  }

}
